import ControlProps from '../../../mixins/ControlProps';
import { TextInputProperty, TextInputType } from '../enums';
import InputProps from '../../../shared/input/mixins/InputProps';
import { InputProperty } from '../../../shared/input/enums';

const TextInputProps = {
  props: {
    ...ControlProps.props,
    [TextInputProperty.IsLoading]: InputProps.props[InputProperty.IsLoading],
    [TextInputProperty.MaxLength]: InputProps.props[InputProperty.MaxLength],
    [TextInputProperty.MinLength]: InputProps.props[InputProperty.MinLength],
    [TextInputProperty.FillType]: InputProps.props[InputProperty.FillType],
    [TextInputProperty.IsReadonly]: InputProps.props[InputProperty.IsReadonly],
    [TextInputProperty.TextType]: {
      default: TextInputType.Text,
      type: String,
    },
  },
};

export default TextInputProps;
